export default (api) => ({
    list: (params) => api.get('/notifications', { params }),
    create: ({ notificationUid }) => api.post(`/notifications/${notificationUid}/seen`),
})
